import './index.css';

export default {
  name: 'Acol',
  props: {
    span: { type: Number | String, default: () => 24 },
    offset: { type: Number | String, default: () => 0 },
    push: { type: Number | String, default: () => 0 },
    pull: { type: Number | String, default: () => 0 },
    flex: { type: Boolean, default: () => true },
  },
  data() {
    return ({
      padding: null,
    });
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      if (this.$parent) {
        const { gutter = 0 } = this.$parent;
        gutter && (this.padding = (`${parseInt(gutter) / 2}px`));
      }
    },
    format(value = null) {
      if (typeof value == 'number') return (`${value}px`);
      if (typeof value == 'string') {
        let suffix = ['%', 'vw', 'vh', 'px', 'em', 'rpx', 'rem'];
        let string = false;
        suffix.forEach(a => {
          if (value.indexOf(a) != -1) string = true;
        });
        return (string ? value : (`${value}px`));
      }
    }
  },
  render() {
    const { width = null, height = null, ...attrs } = this.$attrs;
    return (
      <el-col
        style={{ padding: this.padding, width: this.format(width), height: this.format(height) }}
        offset={parseInt(this.offset)}
        span={parseInt(this.span)}
        push={parseInt(this.push)}
        pull={parseInt(this.pull)}
        class={['a-col', (this.flex ? 'flex' : null)]}
        {...{ attrs }}
      >
        {this.$slots.default}
      </el-col>
    );
  }
}